import React from 'react'
import {connect} from 'react-redux'
import R from 'ramda'

import toggleMore from '../actions/toggleMore'

import getCurrentQuery from '../utils/getCurrentQuery'

const MoreButton = ({onClick,text})=> {
  return <a onClick={onClick} className="btn-more btn btn-primary" style={{textTransform: "initial", right:'3px', bottom:'3px', paddingRight:'2px', paddingLeft:'5px'}}>          
            {text}
         </a>
}

MoreButton.propTypes = {
  onClick: React.PropTypes.func.isRequired,
}

const mapStateToProps = state => {
  return { }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onClick: _ => dispatch(toggleMore())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MoreButton)



/** WEBPACK FOOTER **
 ** ./app/components/MoreButton.jsx
 **/